module.exports = __webpack_public_path__ + "img/infodemics-logo.068d3e44.svg";